"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCellStyled = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("@veeam/components");
const types_1 = require("../types");
exports.TableCellStyled = styled_components_1.default((_a) => {
    var { as, children } = _a, props = __rest(_a, ["as", "children"]);
    return react_1.default.createElement(as || 'tr', components_1.clearProps(props), children);
}) `
  padding-top: ${({ hasPadding, theme }) => (hasPadding ? theme.spacing.s : 'initial')};
  padding-bottom: ${({ hasPadding, theme }) => (hasPadding ? theme.spacing.s : 'initial')};

  width: ${({ widthColumn }) => typeof widthColumn === 'number' ? `${widthColumn}px` : widthColumn || 'initial'};
  max-width: ${({ widthColumn }) => typeof widthColumn === 'number' ? `${widthColumn}px` : widthColumn || 'initial'};

  text-align: ${({ columnAlign }) => columnAlign || types_1.TABLE_COLUMN_ALIGN.left};
  word-break: break-word;
`;
exports.TableCellStyled.displayName = 'TableCellStyled';
//# sourceMappingURL=TableCellStyled.js.map